import { Link } from "react-router-dom";
import BlogPostLayout from "./BlogPostLayout";
import { getPostBySlug } from "../../lib/blog";

const FAQ = [
  {
    q: "Comment différencier des crottes de rat et de souris ?",
    a: "Les crottes de souris sont petites (quelques millimètres) et pointues, souvent éparpillées. Celles de rat sont nettement plus grosses (1 à 2 cm), en forme de gélule, souvent regroupées le long des passages.",
  },
  {
    q: "Par quelle ouverture une souris peut-elle passer ?",
    a: "Une souris peut se faufiler par une ouverture de la taille d'un crayon, un jeune rat par un trou de la taille d'une pièce de monnaie. Tout interstice autour des tuyaux, sous les portes ou dans les maçonneries compte.",
  },
  {
    q: "Les répulsifs à ultrasons sont-ils efficaces ?",
    a: "Leur efficacité est très discutée : les rongeurs s'y habituent souvent rapidement. Ils ne remplacent ni le rebouchage des accès ni la suppression des sources de nourriture.",
  },
  {
    q: "Quand faut-il appeler un professionnel ?",
    a: "Dès que les traces se multiplient malgré vos premières mesures, si vous voyez des rongeurs en journée, si des câbles ou l'isolation sont touchés, ou si le bâtiment accueille des enfants, des animaux ou des denrées alimentaires.",
  },
];

export default function RatsSourisAutomne() {
  const post = getPostBySlug("rats-souris-automne-signes-infestation-prevention");
  return (
    <BlogPostLayout post={post} faq={FAQ}>
      <p className="article-lead">
        Dès que les nuits fraîchissent, rats et souris quittent les champs et les haies pour chercher la chaleur et la
        nourriture. En Creuse, maisons en pierre, granges, caves et poulaillers leur offrent des abris idéaux. Plus vous
        repérez les signes tôt, plus il est simple de régler le problème. Voici les indices à surveiller et les gestes
        de prévention qui fonctionnent.
      </p>

      <h2>Pourquoi l'automne est la saison des rongeurs</h2>
      <p>
        La baisse des températures et la fin des récoltes réduisent la nourriture disponible dehors. Les rongeurs se
        rapprochent alors des bâtiments, où ils trouvent grains, croquettes, compost et recoins chauds. Une fois
        installés, ils se reproduisent vite : quelques individus à l'automne peuvent devenir une vraie colonie en hiver.
      </p>

      <h2>Les signes d'une infestation</h2>
      <h3>Les traces visibles</h3>
      <ul>
        <li>
          <strong>Des crottes</strong> le long des murs, dans les placards, au grenier ou près des réserves.
        </li>
        <li>
          <strong>Des traces grasses</strong> sombres sur les plinthes et les angles, laissées par le pelage aux endroits
          de passage.
        </li>
        <li>
          <strong>Des rongements</strong> sur les sacs, les emballages, le bois, les gaines électriques.
        </li>
        <li>
          <strong>Des nids</strong> faits de papier, d'isolant ou de tissu déchiqueté, cachés derrière l'électroménager
          ou dans les combles.
        </li>
      </ul>
      <h3>Les signes moins évidents</h3>
      <ul>
        <li>Des grattements ou des courses la nuit dans les cloisons et les faux plafonds.</li>
        <li>Une odeur d'urine persistante dans un local fermé.</li>
        <li>Un chien ou un chat qui fixe ou gratte toujours le même endroit.</li>
        <li>Des terriers au pied des murs, des bûchers ou du compost.</li>
      </ul>

      <h2>Pourquoi ne pas laisser traîner</h2>
      <p>
        Les rongeurs souillent les denrées, abîment l'isolation et peuvent ronger les câbles, avec un risque de
        court-circuit. Ils peuvent aussi transmettre des maladies, dont la leptospirose. Pour nettoyer des crottes,
        portez des gants, humidifiez-les avec un désinfectant et ne les balayez pas à sec pour éviter de soulever des
        poussières.
      </p>

      <h2>Le bon réflexe : une inspection en octobre</h2>
      <p>
        Prenez une heure, une lampe et des gants, et faites le tour de la maison et des dépendances avant les premiers
        froids. Regardez sous l'évier, derrière le réfrigérateur et la chaudière, dans la cave, le garage, le grenier et
        l'abri de jardin. Vérifiez les sacs de grain, les cartons stockés au sol et les isolants accessibles. Notez chaque
        indice et chaque ouverture suspecte : cette liste vous servira pour reboucher les accès et, si besoin, pour
        décrire précisément la situation à un professionnel. Renouvelez ce contrôle au cœur de l'hiver.
      </p>

      <h2>La prévention : fermer, ranger, entretenir</h2>
      <h3>Fermer les accès</h3>
      <p>
        Faites le tour du bâtiment : passages de tuyaux, aérations, bas de portes, fissures de maçonnerie. Rebouchez
        avec du mortier, de la laine d'acier ou un grillage galvanisé à mailles fines, et posez des bas de porte à
        brosse sur les accès au garage et à la cave.
      </p>
      <h3>Supprimer la nourriture</h3>
      <p>
        Stockez grains, graines pour oiseaux et croquettes dans des contenants métalliques ou en plastique épais bien
        fermés. Ne laissez pas de nourriture dans les gamelles la nuit, ramassez les restes autour du poulailler et
        évitez les déchets de cuisine dans le compost.
      </p>
      <h3>Entretenir les abords</h3>
      <p>
        Éloignez le tas de bois des murs, dégagez la végétation collée aux façades et rangez les dépendances. Un jardin
        entretenu offre moins de cachettes : notre offre d'
        <Link to="/entretien-jardin-creuse">entretien de jardin en Creuse</Link> peut vous y aider.
      </p>

      <h2>Et si les rongeurs sont déjà là ?</h2>
      <p>
        Les pièges mécaniques bien placés peuvent suffire pour une souris isolée. Si vous utilisez des produits
        rodenticides, respectez strictement l'étiquette et utilisez des postes d'appâtage sécurisés, hors de portée des
        enfants et des animaux. Au-delà de quelques individus, un diagnostic professionnel permet de traiter la source et
        les points d'entrée. C'est l'objet de notre service de{" "}
        <Link to="/deratisation-creuse">dératisation en Creuse</Link>. Pour aller plus loin, lisez aussi{" "}
        <Link to="/conseils/deratisation-creuse-quand-faire-appel-professionnel">
          quand faire appel à un professionnel
        </Link>
        .
      </p>
    </BlogPostLayout>
  );
}
